const homepage = {
  path: 'homepage',
  meta: { index: 0 },
  component: resolve => require(['../../../../../components/pages/student_user/student/homepage'], resolve)
}

export default homepage



// WEBPACK FOOTER //
// ./src/router/pages/student_user/student/homepage/index.js